import { Text } from '@chakra-ui/react';
import { TooltipComponentProps, TooltipTypeEnum } from '@components/map/tooltips/tooltip.types';

function PoiTooltip({ data }: Readonly<TooltipComponentProps<TooltipTypeEnum.POI>>) {
  return <Text textStyle="md">{data.name}</Text>;
}

export default PoiTooltip;
